import { AnalyticsConsent } from './analyticsConsent';

export type AnalyticsEventParameters = Record<string, string | number | boolean>;

export interface AnalyticsDriver {
  enable(): Promise<boolean>;
  disable(): void;
  identify(userId: string | null): void;
  trackPageView(pagePath: string, pageTitle: string): void;
  trackEvent(eventName: string, parameters?: AnalyticsEventParameters): void;
}

export interface AnalyticsController {
  setConsent(consent: Exclude<AnalyticsConsent, 'pending'>): Promise<void>;
  identify(userId: string | null): void;
  trackPageView(pagePath: string, pageTitle: string): void;
  trackEvent(eventName: string, parameters?: AnalyticsEventParameters): void;
}

export const createAnalyticsController = (driver: AnalyticsDriver): AnalyticsController => {
  let consent: AnalyticsConsent = 'pending';
  let enabled = false;
  let currentUserId: string | null = null;
  let currentPage: { path: string; title: string } | null = null;

  return {
    async setConsent(nextConsent) {
      consent = nextConsent;
      if (nextConsent === 'denied') {
        enabled = false;
        driver.disable();
        return;
      }

      const didEnable = await driver.enable();
      if (consent !== 'granted') {
        driver.disable();
        return;
      }

      enabled = didEnable;
      if (!enabled) return;

      driver.identify(currentUserId);
      if (currentPage) {
        driver.trackPageView(currentPage.path, currentPage.title);
      }
    },

    identify(userId) {
      currentUserId = userId;
      if (enabled && consent === 'granted') {
        driver.identify(userId);
      }
    },

    trackPageView(pagePath, pageTitle) {
      currentPage = { path: pagePath, title: pageTitle };
      if (enabled && consent === 'granted') {
        driver.trackPageView(pagePath, pageTitle);
      }
    },

    trackEvent(eventName, parameters) {
      if (enabled && consent === 'granted') {
        driver.trackEvent(eventName, parameters);
      }
    },
  };
};
